import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import { Typography } from '@module/components/Typography/Typography';
import { cn } from '@module/lib/utils';
import { useFetchHeartInfoQuery } from '@module/queries/heart/heartQueryHooks';
import type { ParsedCentrifugeMessage } from '@module/types/centrifuge/messageTypes';
import { isNormalChatMessage } from '@module/types/centrifuge/public-message/normalChatMessageTypes';
import { type ItemCoinMessage, isItemCoinMessage, isSponCoinMessage, type SponCoinMessage } from '@module/types/centrifuge/public-message/sponCoinMessageTypes';
import { findHeartImage, findReactionHeartImage } from '@module/utils/heart/findHeartImage';
import type { Dispatch, SetStateAction } from 'react';
import NormalChat from './NormalChat';
interface Props {
  item: SponCoinMessage | ItemCoinMessage;
  playInfo: PlayInfo;
  isRoomMaster: boolean;
  isManager: boolean;
  userIdx?: number;
  menuVisibleOffset?: number;
  setMenuVisibleOffset?: Dispatch<SetStateAction<number>>;
}
export default function SponChat(t0) {
  const $ = _c(79);
  const {
    item,
    playInfo,
    isRoomMaster,
    isManager,
    userIdx,
    menuVisibleOffset,
    setMenuVisibleOffset
  } = t0;
  const t1 = Number(userIdx);
  let t2;
  if ($[0] !== t1) {
    t2 = {
      userIdx: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !!userIdx;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      enabled: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    data: heartInfo
  } = useFetchHeartInfoQuery(t2, t4);
  if (!heartInfo?.info) {
    return null;
  }
  let t5;
  if ($[4] !== item) {
    t5 = isItemCoinMessage(item);
    $[4] = item;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const isSpecial = t5;
  const t6 = `${item.data.message.coin}`;
  const t7 = heartInfo?.info;
  let t8;
  if ($[6] !== isSpecial || $[7] !== t6 || $[8] !== t7) {
    t8 = findHeartImage(t6, t7, isSpecial ? ["onceCoin", "oneBj", "one", "rangeBj", "range", "defaultBj", "default"] : ["oneBj", "one", "onceCoin", "rangeBj", "range", "defaultBj", "default"]);
    $[6] = isSpecial;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const imageUrl = t8;
  const t9 = heartInfo?.reactionHeart;
  let t10;
  if ($[10] !== item.data.message.coin || $[11] !== t9) {
    t10 = findReactionHeartImage(item.data.message.coin, t9);
    $[10] = item.data.message.coin;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const reactionHeartImage = t10;
  const t11 = item.data?.message?.heartMessage;
  let t12;
  if ($[13] !== imageUrl.type || $[14] !== imageUrl.url || $[15] !== isManager || $[16] !== isRoomMaster || $[17] !== isSpecial || $[18] !== item || $[19] !== menuVisibleOffset || $[20] !== playInfo || $[21] !== reactionHeartImage || $[22] !== setMenuVisibleOffset || $[23] !== t11) {
    const heartMessage = {
      data: {
        ...t11
      },
      offset: item.offset
    } as ParsedCentrifugeMessage;
    let displayImageUrl;
    let isExcel;
    let isNormal;
    let isSignature;
    let t13;
    let t14;
    if ($[25] !== imageUrl.type || $[26] !== imageUrl.url || $[27] !== isSpecial || $[28] !== item || $[29] !== reactionHeartImage) {
      const isBjSignature = isSponCoinMessage(item) && imageUrl.type === "oneBj";
      const isViewerSignature = isSponCoinMessage(item) && "heart" in item.data.message;
      isSignature = isViewerSignature || isBjSignature;
      isNormal = !isSpecial && !isSignature;
      isExcel = !!item.data.message?.excelNick;
      const t15 = isViewerSignature ? item.data.message.heart?.image : null;
      const t16 = isNormal && item.data.message?.reaction ? reactionHeartImage : null;
      let t17;
      if ($[36] !== imageUrl.url || $[37] !== t15 || $[38] !== t16) {
        const heartImageSources = {
          viewerSignature: t15,
          reactionHeart: t16,
          heartImage: imageUrl.url
        };
        t17 = Object.values(heartImageSources).find(_temp) || "";
        $[36] = imageUrl.url;
        $[37] = t15;
        $[38] = t16;
        $[39] = t17;
      } else {
        t17 = $[39];
      }
      displayImageUrl = t17;
      t14 = "mx-auto my-5 text-center text-cht_baseFg";
      t13 = cn("inline-block w-[232px] rounded-[10px] border-2 border-[#01bfb1] py-5", {
        "border-[#a215e4]": isSignature
      });
      $[25] = imageUrl.type;
      $[26] = imageUrl.url;
      $[27] = isSpecial;
      $[28] = item;
      $[29] = reactionHeartImage;
      $[30] = displayImageUrl;
      $[31] = isExcel;
      $[32] = isNormal;
      $[33] = isSignature;
      $[34] = t13;
      $[35] = t14;
    } else {
      displayImageUrl = $[30];
      isExcel = $[31];
      isNormal = $[32];
      isSignature = $[33];
      t13 = $[34];
      t14 = $[35];
    }
    const t15 = item.data.message.nick + item.data.message.coin;
    let t16;
    if ($[40] !== displayImageUrl || $[41] !== t15) {
      t16 = <div className="min-h-[108px] w-full"><img src={displayImageUrl} alt={t15} className="mx-auto mb-4 h-[108px] w-[120px]" /></div>;
      $[40] = displayImageUrl;
      $[41] = t15;
      $[42] = t16;
    } else {
      t16 = $[42];
    }
    const t17 = `${item.data.message.nick}님이`;
    let t18;
    if ($[43] !== t17) {
      t18 = <span className="text-[13px]">{t17}</span>;
      $[43] = t17;
      $[44] = t18;
    } else {
      t18 = $[44];
    }
    let t19;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <div className="-left-1 -right-1 absolute bottom-[-1px] z-[-1] block h-[6px] bg-colorBg_gift_txt_box" />;
      $[45] = t19;
    } else {
      t19 = $[45];
    }
    const t20 = `${item.data.message.coin}개`;
    let t21;
    if ($[46] !== t20) {
      t21 = <span className="relative mr-[4px] inline h-[17px] font-[700]">{t19}{t20}</span>;
      $[46] = t20;
      $[47] = t21;
    } else {
      t21 = $[47];
    }
    let t22;
    if ($[48] !== isNormal || $[49] !== item.data.message.reaction) {
      t22 = isNormal && <span className="relative inline h-[17px]"><div className="-left-1 -right-1 absolute bottom-[-1px] z-[-1] block h-[6px] bg-colorBg_gift_txt_box" />{item.data.message.reaction ? "\uB9AC\uC561\uC158" : ""}하트 선물!</span>;
      $[48] = isNormal;
      $[49] = item.data.message.reaction;
      $[50] = t22;
    } else {
      t22 = $[50];
    }
    let t23;
    if ($[51] !== isSpecial) {
      t23 = isSpecial && <span className="relative inline h-[17px]"><div className="-left-1 -right-1 absolute bottom-[-1px] z-[-1] block h-[6px] bg-colorBg_gift_txt_box" />스페셜하트 선물!</span>;
      $[51] = isSpecial;
      $[52] = t23;
    } else {
      t23 = $[52];
    }
    let t24;
    if ($[53] !== isSignature) {
      t24 = isSignature && <span className="relative inline h-[17px]"><div className="-left-1 -right-1 absolute bottom-[-1px] z-[-1] block h-[6px] bg-colorBg_gift_txt_box" />시그니처하트 선물!</span>;
      $[53] = isSignature;
      $[54] = t24;
    } else {
      t24 = $[54];
    }
    let t25;
    if ($[55] !== t21 || $[56] !== t22 || $[57] !== t23 || $[58] !== t24) {
      t25 = <div className="relative isolate flex flex-wrap justify-center text-[13px] text-colorFg_gift">{t21}{t22}{t23}{t24}</div>;
      $[55] = t21;
      $[56] = t22;
      $[57] = t23;
      $[58] = t24;
      $[59] = t25;
    } else {
      t25 = $[59];
    }
    let t26;
    if ($[60] !== isSpecial || $[61] !== item.data.message.reaction) {
      t26 = !isSpecial && item.data.message.reaction && <div className="py-2"><Typography variant="caption-1" color="blue">{item.data.message.reaction.name.ko}</Typography></div>;
      $[60] = isSpecial;
      $[61] = item.data.message.reaction;
      $[62] = t26;
    } else {
      t26 = $[62];
    }
    let t27;
    if ($[63] !== t18 || $[64] !== t25 || $[65] !== t26) {
      t27 = <div className="flex flex-col items-center justify-center whitespace-pre-line break-all">{t18}{t25}{t26}</div>;
      $[63] = t18;
      $[64] = t25;
      $[65] = t26;
      $[66] = t27;
    } else {
      t27 = $[66];
    }
    let t28;
    if ($[67] !== t13 || $[68] !== t16 || $[69] !== t27) {
      t28 = <div className={t13}>{t16}{t27}</div>;
      $[67] = t13;
      $[68] = t16;
      $[69] = t27;
      $[70] = t28;
    } else {
      t28 = $[70];
    }
    let t29;
    if ($[71] !== t14 || $[72] !== t28) {
      t29 = <div className={t14}>{t28}</div>;
      $[71] = t14;
      $[72] = t28;
      $[73] = t29;
    } else {
      t29 = $[73];
    }
    let t30;
    if ($[74] !== isExcel || $[75] !== item.data.message.coin || $[76] !== item.data.message.excelNick || $[77] !== item.data.message.excelType) {
      t30 = isExcel && <><div className="whitespace-pre-wrap text-[13px]">{item.data.message.excelType === "plus" && <div className="text-[#D50000]">{`${item.data.message.excelNick} 님에게`}<span className="mx-1 font-bold">{`${item.data.message.coin}개`}</span>{"\uD50C\uB7EC\uC2A4 \uD558\uD2B8 \uC120\uBB3C!"}</div>}{item.data.message.excelType === "minus" && <div className="text-[#2962FF]">{`${item.data.message.excelNick} 님에게`}<span className="mx-1 font-bold">{`${item.data.message.coin}개`}</span>{"\uB9C8\uC774\uB108\uC2A4 \uD558\uD2B8 \uC120\uBB3C!"}</div>}</div></>;
      $[74] = isExcel;
      $[75] = item.data.message.coin;
      $[76] = item.data.message.excelNick;
      $[77] = item.data.message.excelType;
      $[78] = t30;
    } else {
      t30 = $[78];
    }
    t12 = <>{t29}{t30}{playInfo.chatMode !== "hide" && item.data?.message?.heartMessage && isNormalChatMessage(heartMessage) && <NormalChat item={heartMessage} playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} menuVisibleOffset={menuVisibleOffset} setMenuVisibleOffset={setMenuVisibleOffset} />}</>;
    $[13] = imageUrl.type;
    $[14] = imageUrl.url;
    $[15] = isManager;
    $[16] = isRoomMaster;
    $[17] = isSpecial;
    $[18] = item;
    $[19] = menuVisibleOffset;
    $[20] = playInfo;
    $[21] = reactionHeartImage;
    $[22] = setMenuVisibleOffset;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp(url) {
  return url;
}